type Checkable = { checked: boolean };

export type SelectAllState = {
  checkedCount: number;
  allChecked: boolean;
  someChecked: boolean;
};

// Derives the tri-state for a "Select All" checkbox from the item list:
// allChecked (every item checked), someChecked (indeterminate), or neither.
export const getSelectAllState = (items: Checkable[]): SelectAllState => {
  const checkedCount = items.filter((item) => item.checked).length;
  const allChecked = items.length > 0 && checkedCount === items.length;
  const someChecked = checkedCount > 0 && !allChecked;

  return { checkedCount, allChecked, someChecked };
};

// Toggles every item: if all are currently checked, clears them; otherwise
// checks them all. Returns a new array (does not mutate the input).
export const applySelectAll = <T extends Checkable>(items: T[]): T[] => {
  const { allChecked } = getSelectAllState(items);

  return items.map((item) => ({ ...item, checked: !allChecked }));
};
